import { ICON_MAP } from "./navConstants";

export function ClubSwitcher({ clubBadges, activeClub, setActiveClub, location, navigate }) {
  return (
    <div className="hidden md:flex items-center gap-1.5">
      {clubBadges.map(club => {
        const Icon = ICON_MAP[club.icon];
        const isOnClubPage = location.pathname.startsWith('/club/');
        return (
          <button key={club.id} data-testid={`club-switch-${club.id}`}
            onClick={() => {
              setActiveClub(activeClub === club.id ? null : club.id);
              if (isOnClubPage) {
                navigate(`/club/${club.id}`);
              }
            }}
            className={`club-badge p-2 rounded-full border-2 ${activeClub === club.id ? '' : 'border-transparent opacity-50 hover:opacity-100'}`}
            style={{ color: club.accent, borderColor: activeClub === club.id ? club.accent : 'transparent' }}
            title={club.name}>
            <Icon className="w-5 h-5" />
          </button>
        );
      })}
    </div>
  );
}
